import { render, staticRenderFns } from "./CardPemeriksaanPerawat.vue?vue&type=template&id=b697400c&scoped=true&"
import script from "./CardPemeriksaanPerawat.vue?vue&type=script&lang=ts&"
export * from "./CardPemeriksaanPerawat.vue?vue&type=script&lang=ts&"
import style0 from "./CardPemeriksaanPerawat.vue?vue&type=style&index=0&id=b697400c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b697400c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VRow})
